<div class="modal fade" id="private-password-modal" aria-labelledby="private-password-modal" role="dialog" tabindex="-1"
  aria-hidden="true" [ngStyle]="{'display': showPrivateFoldePasswordModal ? 'block' : 'none','opacity': 1, 'background' : 'rgba(0,0,0,0.5)', 'backdrop-filter':'blur(10px)','-webkit-backdrop-filter':'blur(10px)','transition':'all ease-in .1s'}">

  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content h-90">
      <div class="modal-header border-bottom-0">
        <button type="button" class="close btn-pos" data-dismiss="modal" (click)="closePopUp()">
          <span class="NeueFile_Cancel"></span>
          <span class="esc">esc</span>
        </button>
        <span class="NeueFile_Cancel m-close d-md-none" data-dismiss="modal" (click)="closePopUp()"></span>
        <div class="lock-wrap">
          <span class="Neuelock_filled"></span>
        </div>
        <h5>Enter password for "Private Folder"</h5>
      </div>
    <div class="modal-body border-bottom-0 pl-md-5 pr-md-5 pt-md-4">

      <div class="renameContent">
        <input #pwd id="pfpassword" type="password" maxlength="20" autofocus placeholder="Enter password" (input)="validateEmptyText(pwd)" />
        <button (click)="showHidePaasword()" aria-label="Password toggle button" class="eyeBtn" [disabled]="pwd.value == ''">
          @if (!show) {
            <i class="NeuePassword-Show" title="Show Passphrase" aria-hidden="true"></i>
          }
          @if (show) {
            <i class="NeuePassword-Hide" title="Hide Passphrase" aria-hidden="true"></i>
          }
        </button>
        <div class="inputError">
          @if (this.implRef.passwordError!='') {
            <span><i class="NeueAlert mr-1"></i>{{this.implRef.passwordError}}</span>
          }
        </div>
      </div>

    </div>
    <div class="modal-footer m-0 border-top-0 pl-md-5 pr-md-5 pb-md-5 pb-4">
      <div class="rename-btn-main mt-3">
        <button [disabled]="!enableButton" class="pointer" (click)="unlock(pwd)">Unlock Private Folder</button>
      </div>
    </div>
  </div>
</div>
</div>
